import React from 'react';
import ExpectJobTitle from '@/components/resume/resume-evaluation/ExpectJobTitle';
import SvgEdit from '@/components/resume/resume-evaluation/SvgEdit';

const UploadInfo = (props: {
  resumeFile: File | null;
  dataEleGroup: string;
}) => {
  const { resumeFile, dataEleGroup } = props;
  const [uploading, setUploading] = React.useState(false);

  return (
    <div className="px-4 py-4 rounded-lg w-full mx-auto tablet:max-w-[600px] tablet:px-10 tablet:py-14 tablet:bg-white">
      <div className="text-lg mb-5 font-semibold flex items-center tablet:text-xl">
        <SvgEdit className="shrink-0" />
        <p className="ml-2">谈职将结合目标岗位为您生成简历诊断报告</p>
      </div>
      <ExpectJobTitle
        resumeFile={resumeFile}
        uploading={uploading}
        setUploading={setUploading}
        autoCompleteClassName="mb-8 tablet:mb-[135px]"
        dataEleGroup={dataEleGroup}
      />
    </div>
  );
};

export default UploadInfo;
